import { UpChunk } from "@mux/upchunk";

export const handleUploadVideo = (file: File, uploadUrl: string, setFileUploadingPercent: (progress: number) => void): Promise<string> => new Promise((resolve, reject) => {
  const upload = UpChunk.createUpload({
    endpoint: uploadUrl,
    file,
    dynamicChunkSize: true
  });

  upload.on('error', err => {
    reject(err);
  });

  upload.on('progress', (progress) => {
    setFileUploadingPercent(Math.floor(progress.detail));
  });

  upload.on('success', (res,...others) => {
    resolve(uploadUrl);
  });
});
